/* ============================================================
   3D Furniture Configurator PRO v3 (multilingual: RU / EN / HY)
   - Procedural wood textures (canvas), cached materials
   - UI strings fully localized via STRINGS[locale]
   - Fixed leg placement for round/oval tabletops
   - Added sofa categories: straight & corner
   ============================================================ */

(function () {
  "use strict";

  var LOCALE = (window.configuratorLocale || "ru").toLowerCase();
  if (LOCALE !== "en" && LOCALE !== "hy") LOCALE = "ru";

  var STRINGS = {
    ru: {
      canvasHint: "Крутите модель мышкой",
      smartLabel: "Опишите мебель словами · RU · EN · HY",
      smartPlaceholder: "белый шкаф 2 метра с ящиками",
      buildBtn: "Собрать",
      categoryLabel: "Категория",
      widthLabel: "Ширина", heightLabel: "Высота", depthLabel: "Глубина", mmUnit: "мм",
      materialLabel: "Материал",
      arBtn: "Смотреть в AR", shareBtn: "Поделиться",
      hintText: "Соберите мебель под свои размеры и посмотрите в 3D. «Поделиться» сохраняет конфигурацию в ссылку.",
      linkCopied: "Ссылка скопирована!",
      arUnavailable: "AR-экспорт недоступен",
      helpText: "Не распознал. Примеры: «белый шкаф 2 метра с ящиками» · «round oak table» · «սպիտակ պահարան»",
      topShapeLabel: "Форма столешницы",
      topShapeOptions: { rect: "Прямоугольная", square: "Квадратная", round: "Круглая", oval: "Овальная" },
      cornerRadiusLabel: "Скругление углов (мм)",
      legTypeLabel: "Тип ножек",
      handleLabel: "Ручки",
      facadeLabel: "Фасад",
      facadeOptions: { swing: "Распашной", flap: "Откидной", niche: "Открытая ниша" },
      mountLabel: "Монтаж",
      mountOptions: { "false": "Напольная", "true": "Подвесная" },
      sinkTypeLabel: "Раковина",
      sinkTypeOptions: { vessel: "Накладная чаша", undermount: "Врезная" },
      ledLabel: "LED-подсветка",
      onOff: { "false": "Выкл", "true": "Вкл" },
      yesNo: { "false": "Нет", "true": "Есть" },
      shelvesLabel: "Полки (шт)", drawersLabel: "Ящики (шт)", rodLabel: "Штанга для одежды",
      sinkLabel: "Мойка", hobLabel: "Варочная панель",
      sofaTypeLabel: "Форма дивана",
      sofaTypeOptions: { straight: "Прямой", corner: "Угловой" },
      cornerSideLabel: "Угол",
      cornerSideOptions: { left: "Левый", right: "Правый" },
      cushionsLabel: "Подушки (шт)",
      fb: {
        widthPrefix: "Ш ", mm: "мм",
        round: "круглая", oval: "овальная", square: "квадратная",
        withDrawers: "с ящиками", moreDrawers: "больше ящиков", rod: "штанга",
        metalLegs: "металл-ножки", led: "LED", sink: "мойка", hob: "варочная",
        wallMounted: "подвесная", floorStanding: "напольная",
        corner: "угловой", straight: "прямой"
      },
      types: {
        stol: "Стол", shkaf: "Шкаф", tv_tumba: "ТВ-тумба", navesnoy: "Навесной шкаф",
        polka: "Полка", sanuzel: "Тумба санузел", krovat: "Кровать", komod: "Комод",
        tumba_prikr: "Прикроватная тумба", kuhnya: "Кухня (прямая)", penal: "Пенал (санузел)",
        zerkalo: "Зеркальный шкаф", divan_straight: "Диван прямой", divan_corner: "Диван угловой"
      },
      materials: {
        dub_natur: "Дуб натуральный", dub_gold: "Дуб золотой", orekh: "Орех", orekh_dark: "Орех тёмный",
        buk: "Бук", yasen: "Ясень", venge: "Венге", sonoma: "Дуб сонома", wenge_gray: "Дуб графит",
        white: "Белый", white_soft: "Белый софт", graphite: "Графит", black: "Чёрный",
        anthracite: "Антрацит", beige: "Бежевый", sage: "Шалфей", blue_gray: "Сине-серый",
        terracotta: "Терракота", cream: "Крем"
      },
      handles: { profile: "Профиль", knob: "Накладная", tipon: "Tip-On (без ручки)" },
      legs: { wood: "Деревянные", metal: "Металл-лофт", hidden: "Скрытые" }
    },
    en: {
      canvasHint: "Drag to rotate the model",
      smartLabel: "Describe the furniture — RU · EN · HY",
      smartPlaceholder: "white wardrobe 2 meters with drawers",
      buildBtn: "Build",
      categoryLabel: "Category",
      widthLabel: "Width", heightLabel: "Height", depthLabel: "Depth", mmUnit: "mm",
      materialLabel: "Material",
      arBtn: "View in AR", shareBtn: "Share",
      hintText: "Build furniture to your exact dimensions and preview it in 3D. \"Share\" saves your configuration as a link.",
      linkCopied: "Link copied!",
      arUnavailable: "AR export unavailable",
      helpText: "Couldn’t recognize that. Try: «white wardrobe 2 meters with drawers» · «round oak table» «սպիտակ պահարան»",
      topShapeLabel: "Top Shape",
      topShapeOptions: { rect: "Rectangular", square: "Square", round: "Round", oval: "Oval" },
      cornerRadiusLabel: "Corner Radius (mm)",
      legTypeLabel: "Leg Type",
      handleLabel: "Handles",
      facadeLabel: "Front Style",
      facadeOptions: { swing: "Swing Door", flap: "Flip-Up", niche: "Open Niche" },
      mountLabel: "Mounting",
      mountOptions: { "false": "Floor-standing", "true": "Wall-mounted" },
      sinkTypeLabel: "Sink",
      sinkTypeOptions: { vessel: "Vessel", undermount: "Undermount" },
      ledLabel: "LED Lighting",
      onOff: { "false": "Off", "true": "On" },
      yesNo: { "false": "No", "true": "Yes" },
      shelvesLabel: "Shelves (qty)", drawersLabel: "Drawers (qty)", rodLabel: "Hanging Rod",
      sinkLabel: "Sink", hobLabel: "Hob",
      sofaTypeLabel: "Sofa Shape",
      sofaTypeOptions: { straight: "Straight", corner: "Corner" },
      cornerSideLabel: "Corner Side",
      cornerSideOptions: { left: "Left", right: "Right" },
      cushionsLabel: "Cushions (qty)",
      fb: {
        widthPrefix: "W ", mm: "mm",
        round: "round", oval: "oval", square: "square",
        withDrawers: "with drawers", moreDrawers: "more drawers", rod: "hanging rod",
        metalLegs: "metal legs", led: "LED", sink: "sink", hob: "hob",
        wallMounted: "wall-mounted", floorStanding: "floor-standing",
        corner: "corner", straight: "straight"
      },
      types: {
        stol: "Table", shkaf: "Wardrobe", tv_tumba: "TV Stand", navesnoy: "Wall Cabinet",
        polka: "Shelf", sanuzel: "Bathroom Vanity", krovat: "Bed", komod: "Dresser",
        tumba_prikr: "Nightstand", kuhnya: "Kitchen (straight)", penal: "Tall Cabinet (bathroom)",
        zerkalo: "Mirror Cabinet", divan_straight: "Straight Sofa", divan_corner: "Corner Sofa"
      },
      materials: {
        dub_natur: "Natural Oak", dub_gold: "Golden Oak", orekh: "Walnut", orekh_dark: "Dark Walnut",
        buk: "Beech", yasen: "Ash", venge: "Wenge", sonoma: "Sonoma Oak", wenge_gray: "Graphite Oak",
        white: "White", white_soft: "Soft White", graphite: "Graphite", black: "Black",
        anthracite: "Anthracite", beige: "Beige", sage: "Sage", blue_gray: "Blue-Grey",
        terracotta: "Terracotta", cream: "Cream"
      },
      handles: { profile: "Profile", knob: "Knob", tipon: "Tip-On (handleless)" },
      legs: { wood: "Wood", metal: "Metal Loft", hidden: "Hidden" }
    },
    hy: {
      canvasHint: "Պտտեք մոդելը մկնիկով",
      smartLabel: "Նկարագրեք կահույքը — RU · EN · HY",
      smartPlaceholder: "սպիտակ պահարան 2 մետր դարակներով",
      buildBtn: "Հավաքել",
      categoryLabel: "Կատեգորիա",
      widthLabel: "Լայնություն", heightLabel: "Բարձրություն", depthLabel: "Խորություն", mmUnit: "մմ",
      materialLabel: "Նյութ",
      arBtn: "Դիտել AR-ով", shareBtn: "Կիսվել",
      hintText: "Հավաքեք կահույքը ձեր չափերով և դիտեք 3D-ով։ «Կիսվել» կոճը պահպանի հղումով։",
      linkCopied: "Հղումը պատճենվեց!",
      arUnavailable: "AR արտահանումն անհասանելի է",
      helpText: "Ձեր ասված չէ: «սպիտակ պահարան 2 մետր դարակներով» · «round oak table»",
      topShapeLabel: "Սեղանապի ձև",
      topShapeOptions: { rect: "Ուղղանկյուն", square: "Քառակուսի", round: "Կլոր", oval: "Օվալ" },
      cornerRadiusLabel: "Քանգերի քանդակում (մմ)",
      legTypeLabel: "Օտքերի տեսակ",
      handleLabel: "Քաշեր",
      facadeLabel: "Ւմը",
      facadeOptions: { swing: "Բացվող", flap: "Փակվող", niche: "Բաց բնիչ" },
      mountLabel: "Թողակայքման տեսակ",
      mountOptions: { "false": "Հատակային", "true": "Պատին հարուած" },
      sinkTypeLabel: "Առան",
      sinkTypeOptions: { vessel: "Նավակիանային", undermount: "Ներքաշ" },
      ledLabel: "LED լուսավորում",
      onOff: { "false": "Անշունց", "true": "Անվանել" },
      yesNo: { "false": "Չկա", "true": "Կա" },
      shelvesLabel: "Դարակներ (հատ)", drawersLabel: "Դուռեր (հատ)", rodLabel: "Հագուստի ցոժ",
      sinkLabel: "Առան", hobLabel: "Հնոցատաժար",
      sofaTypeLabel: "Բազմոցի ձև",
      sofaTypeOptions: { straight: "Ուղղակի", corner: "Անկյունային" },
      cornerSideLabel: "Անկյուն",
      cornerSideOptions: { left: "Լայ", right: "Ձախ" },
      cushionsLabel: "Բարձեր (հատ)",
      fb: {
        widthPrefix: "Լ ", mm: "մմ",
        round: "օրում", oval: "օվալ", square: "քառակուսի",
        withDrawers: "դուռերով", moreDrawers: "ավելի դուռեր", rod: "ցոժ",
        metalLegs: "մետաղ ոտքեր", led: "LED", sink: "առան", hob: "ոցականակ",
        wallMounted: "պատին", floorStanding: "հատակային",
        corner: "անկյունային", straight: "ուղղակի"
      },
      types: {
        stol: "Սեղան", shkaf: "Պահարան", tv_tumba: "հեռուստացույցի տումբա", navesnoy: "Պատին պահարան",
        polka: "Դարակ", sanuzel: "Սանհանգյուին տումբա", krovat: "Ատամնի", komod: "Կոմոդ",
        tumba_prikr: "Ատամնակից տումբա", kuhnya: "խոհանոց (ուղղակի)", penal: "Բարձր պահարան",
        zerkalo: "Հայելի պահարան", divan_straight: "Ուղղակի բազմոց", divan_corner: "Անկյունային բազմոց"
      },
      materials: {
        dub_natur: "Բնական կաղնի", dub_gold: "Ոսկեգույն կաղնի", orekh: "Կակաոց", orekh_dark: "Մուգ կակաոց",
        buk: "Հացի", yasen: "հացի", venge: "Վենգե", sonoma: "Սոնոմա կաղնի", wenge_gray: "Գրաֆիտ կաղնի",
        white: "Սպիտակ", white_soft: "Նուրբ սպիտակ", graphite: "Գրաֆիտ", black: "Սև",
        anthracite: "Անթրացիտ", beige: "Բեժ", sage: "Առողջին", blue_gray: "Կապոյտ-մուգ",
        terracotta: "Տերակոտա", cream: "Կրեմ"
      },
      handles: { profile: "Պրոֆիլ", knob: "Նականանովի", tipon: "Tip-On (առանց քաշի)" },
      legs: { wood: "Փայտե", metal: "Մետաղական", hidden: "Թաքնված" }
    }
  };
  var T = STRINGS[LOCALE];

  function makeWoodTexture(baseHex, opts) {
    opts = opts || {};
    const size = 512;
    const canvas = document.createElement("canvas");
    canvas.width = size; canvas.height = size;
    const ctx = canvas.getContext("2d");

    const base = hexToRgb(baseHex);
    const dark = opts.dark || shade(base, -0.35);
    const light = opts.light || shade(base, 0.18);

    ctx.fillStyle = rgbStr(base);
    ctx.fillRect(0, 0, size, size);

    const grainCount = opts.grainCount || 140;
    for (let i = 0; i < grainCount; i++) {
      const y = Math.random() * size;
      const amp = 6 + Math.random() * 14;
      const freq = 0.004 + Math.random() * 0.006;
      const phase = Math.random() * Math.PI * 2;
      const w = 0.5 + Math.random() * 2.2;
      const tone = Math.random() < 0.5 ? dark : light;
      const alpha = 0.04 + Math.random() * 0.16;
      ctx.strokeStyle = "rgba(" + tone.r + "," + tone.g + "," + tone.b + "," + alpha + ")";
      ctx.lineWidth = w;
      ctx.beginPath();
      for (let x = 0; x <= size; x += 4) {
        const yy = y + Math.sin(x * freq + phase) * amp;
        if (x === 0) ctx.moveTo(x, yy); else ctx.lineTo(x, yy);
      }
      ctx.stroke();
    }

    const pores = opts.pores !== false ? 900 : 0;
    for (let i = 0; i < pores; i++) {
      const x = Math.random() * size, y = Math.random() * size;
      const r = 0.3 + Math.random() * 0.9;
      ctx.fillStyle = "rgba(" + dark.r + "," + dark.g + "," + dark.b + "," + (0.05 + Math.random()*0.12) + ")";
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI*2); ctx.fill();
    }

    const knots = opts.knots != null ? opts.knots : 2;
    for (let i = 0; i < knots; i++) {
      const kx = 60 + Math.random() * (size - 120);
      const ky = 60 + Math.random() * (size - 120);
      const kr = 8 + Math.random() * 14;
      const grad = ctx.createRadialGradient(kx, ky, 1, kx, ky, kr);
      grad.addColorStop(0, rgbStr(shade(base, -0.5)));
      grad.addColorStop(1, "rgba(0,0,0,0)");
      ctx.fillStyle = grad;
      ctx.beginPath(); ctx.arc(kx, ky, kr, 0, Math.PI*2); ctx.fill();
    }

    const tex = new THREE.CanvasTexture(canvas);
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
    tex.encoding = THREE.sRGBEncoding;
    return tex;
  }

  function makeNoiseNormal() {
    const size = 256;
    const canvas = document.createElement("canvas");
    canvas.width = size; canvas.height = size;
    const ctx = canvas.getContext("2d");
    const img = ctx.createImageData(size, size);
    for (let i = 0; i < img.data.length; i += 4) {
      const n = 128 + (Math.random() - 0.5) * 40;
      img.data[i] = 128; img.data[i+1] = 128; img.data[i+2] = 255; img.data[i+3] = 255;
      img.data[i] = n;
    }
    ctx.putImageData(img, 0, 0);
    const tex = new THREE.CanvasTexture(canvas);
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
    return tex;
  }

  function hexToRgb(hex){ return { r:(hex>>16)&255, g:(hex>>8)&255, b:hex&255 }; }
  function rgbStr(c){ return "rgb(" + c.r + "," + c.g + "," + c.b + ")"; }
  function shade(c, amt){
    const f = amt < 0 ? 0 : 255, p = Math.abs(amt);
    return { r: Math.round((f-c.r)*p)+c.r, g: Math.round((f-c.g)*p)+c.g, b: Math.round((f-c.b)*p)+c.b };
  }

  const MATERIALS = {
    dub_natur:  { type: "wood", base: 0xc9a876, grainCount: 130, baseRoughness: 0.62 },
    dub_gold:   { type: "wood", base: 0xd9ad5f, grainCount: 130, baseRoughness: 0.58 },
    orekh:      { type: "wood", base: 0x6b4530, grainCount: 150, baseRoughness: 0.58 },
    orekh_dark: { type: "wood", base: 0x4a2e20, grainCount: 160, baseRoughness: 0.55 },
    buk:        { type: "wood", base: 0xd8b489, grainCount: 110, pores: false, knots: 0, baseRoughness: 0.55 },
    yasen:      { type: "wood", base: 0xe0cba8, grainCount: 120, baseRoughness: 0.6 },
    venge:      { type: "wood", base: 0x3a2b26, grainCount: 170, baseRoughness: 0.5 },
    sonoma:     { type: "wood", base: 0xbfa584, grainCount: 120, baseRoughness: 0.62 },
    wenge_gray: { type: "wood", base: 0x6d6560, grainCount: 140, baseRoughness: 0.6 },
    white:      { type: "solid", color: 0xf4f3f0, roughness: 0.65 },
    white_soft: { type: "solid", color: 0xeeecE6, roughness: 0.85 },
    graphite:   { type: "solid", color: 0x3a3d42, roughness: 0.7 },
    black:      { type: "solid", color: 0x1b1b1d, roughness: 0.8 },
    anthracite: { type: "solid", color: 0x2b2f33, roughness: 0.75 },
    beige:      { type: "solid", color: 0xd9cbb3, roughness: 0.7 },
    sage:       { type: "solid", color: 0x8a9a7b, roughness: 0.72 },
    blue_gray:  { type: "solid", color: 0x5f7080, roughness: 0.72 },
    terracotta: { type: "solid", color: 0xb5715a, roughness: 0.72 },
    cream:      { type: "solid", color: 0xe8ddc7, roughness: 0.7 },
  };

  const HANDLE_TYPES = { profile:1, knob:1, tipon:1 };
  const LEG_TYPES = { wood:1, metal:1, hidden:1 };

  const FURNITURE_TYPES = {
    stol: { builder:buildTable,
      limits:{width:[600,2400],height:[650,1100],depth:[500,1200]}, defaults:{width:1400,height:750,depth:800},
      options:{topShape:true,cornerRadius:true,legType:true} },
    shkaf: { builder:buildWardrobe,
      limits:{width:[800,3000],height:[1500,2600],depth:[400,700]}, defaults:{width:1800,height:2200,depth:600},
      options:{fill:true,handle:true,mountToggle:true} },
    tv_tumba: { builder:buildTVStand,
      limits:{width:[1000,2400],height:[350,600],depth:[350,500]}, defaults:{width:1600,height:450,depth:400},
      options:{handle:true,mountToggle:true,facade:true} },
    navesnoy: { builder:buildWallCabinet, mounted:true,
      limits:{width:[400,2000],height:[300,1000],depth:[250,450]}, defaults:{width:800,height:700,depth:350},
      options:{handle:true,facade:true} },
    polka: { builder:buildWallShelf, mounted:true,
      limits:{width:[400,2000],height:[30,60],depth:[150,350]}, defaults:{width:1000,height:40,depth:250}, options:{} },
    sanuzel: { builder:buildBathVanity, mounted:true,
      limits:{width:[500,1200],height:[400,600],depth:[350,500]}, defaults:{width:800,height:480,depth:450},
      options:{sinkType:true,led:true,handle:true} },
    krovat: { builder:buildBed,
      limits:{width:[900,2200],height:[300,1200],depth:[1900,2200]}, defaults:{width:1600,height:900,depth:2000},
      options:{legType:true} },
    komod: { builder:buildDresser,
      limits:{width:[600,1800],height:[600,1300],depth:[350,550]}, defaults:{width:1000,height:850,depth:450},
      options:{drawersOnly:true, handle:true} },
    tumba_prikr: { builder:buildDresser,
      limits:{width:[350,700],height:[300,700],depth:[300,450]}, defaults:{width:500,height:500,depth:400},
      options:{drawersOnly:true, handle:true} },
    kuhnya: { builder:buildKitchen,
      limits:{width:[1200,4000],height:[2000,2400],depth:[560,650]}, defaults:{width:3000,height:2200,depth:600},
      options:{handle:true, sinkCut:true, hobCut:true} },
    penal: { builder:buildTallCabinet, mounted:true,
      limits:{width:[300,600],height:[1200,2000],depth:[300,400]}, defaults:{width:400,height:1600,depth:350},
      options:{handle:true} },
    zerkalo: { builder:buildMirrorCabinet, mounted:true,
      limits:{width:[500,1200],height:[500,900],depth:[120,200]}, defaults:{width:800,height:700,depth:150},
      options:{led:true} },
    divan_straight: { builder:buildSofaStraight,
      limits:{width:[1400,3200],height:[700,950],depth:[850,1100]}, defaults:{width:2000,height:850,depth:950},
      options:{legType:true, cushions:true} },
    divan_corner: { builder:buildSofaCorner,
      limits:{width:[2000,3600],height:[700,950],depth:[1500,2200]}, defaults:{width:2600,height:850,depth:1700},
      options:{legType:true, cornerSide:true, cushions:true} },
  };

  const state = {
    type:"stol", material:"dub_natur",
    width:1400, height:750, depth:800,
    topShape:"rect", cornerRadius:20, legType:"wood",
    handle:"profile", facade:"swing", mounted:false,
    sinkType:"vessel", led:false,
    shelves:3, drawers:1, rod:true,
    dresserDrawers:3, sinkCut:true, hobCut:true,
    cornerSide:"left", cushions:3,
  };

  let scene, camera, renderer, controls, currentModel;
  const MM = 0.001;

  const woodTexCache = {};
  const noiseNormal = { tex: null };

  function getWoodMaps(materialKey) {
    if (woodTexCache[materialKey]) return woodTexCache[materialKey];
    const m = MATERIALS[materialKey];
    const colorTex = makeWoodTexture(m.base, { grainCount: m.grainCount, pores: m.pores, knots: m.knots });
    if (!noiseNormal.tex) noiseNormal.tex = makeNoiseNormal();
    const maps = { color: colorTex, normal: noiseNormal.tex };
    woodTexCache[materialKey] = maps;
    return maps;
  }

  const materialCache = {};
  function getMaterial(materialKey) {
    if (materialCache[materialKey]) return materialCache[materialKey];
    const m = MATERIALS[materialKey];
    let mat;
    if (m.type === "solid") {
      mat = new THREE.MeshStandardMaterial({ color: m.color, roughness: m.roughness, metalness: 0 });
    } else {
      const maps = getWoodMaps(materialKey);
      mat = new THREE.MeshStandardMaterial({
        map: maps.color.clone(), normalMap: maps.normal.clone(),
        normalScale: new THREE.Vector2(0.3, 0.3), roughness: m.baseRoughness, metalness: 0,
      });
      mat.map.wrapS = mat.map.wrapT = THREE.RepeatWrapping;
      mat.map.encoding = THREE.sRGBEncoding;
      mat.normalMap.wrapS = mat.normalMap.wrapT = THREE.RepeatWrapping;
    }
    materialCache[materialKey] = mat;
    return mat;
  }

  function panelMaterial(materialKey, realW, realH) {
    const m = MATERIALS[materialKey];
    const src = getMaterial(materialKey);
    if (m.type === "solid") return src;
    const scale = 0.6;
    const rx = Math.max(1, realW / scale), ry = Math.max(1, realH / scale);
    const mat = src.clone();
    mat.map = src.map.clone(); mat.map.needsUpdate = true; mat.map.repeat.set(rx, ry);
    mat.map.wrapS = mat.map.wrapT = THREE.RepeatWrapping; mat.map.encoding = THREE.sRGBEncoding;
    mat.normalMap = src.normalMap.clone(); mat.normalMap.needsUpdate = true; mat.normalMap.repeat.set(rx, ry);
    mat.normalMap.wrapS = mat.normalMap.wrapT = THREE.RepeatWrapping;
    return mat;
  }

  function metalMaterial(){ return new THREE.MeshStandardMaterial({ color:0x8a8d92, metalness:0.85, roughness:0.28 }); }
  function fabricMaterial(materialKey){
    const m = MATERIALS[materialKey];
    const color = m.type === "solid" ? m.color : m.base;
    return new THREE.MeshStandardMaterial({ color: color, roughness: 0.92, metalness: 0 });
  }

  function initScene() {
    const canvas = document.getElementById("configurator-canvas");
    const holder = canvas.parentElement;
    scene = new THREE.Scene();
    scene.background = new THREE.Color(0xe4d3c6);
    camera = new THREE.PerspectiveCamera(40, holder.clientWidth/holder.clientHeight, 0.01, 100);
    camera.position.set(2.2, 1.6, 3.0);
    renderer = new THREE.WebGLRenderer({ canvas, antialias:true, preserveDrawingBuffer:true });
    renderer.setSize(holder.clientWidth, holder.clientHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.maxPolarAngle = Math.PI/2;
    controls.target.set(0, 0.6, 0);
    controls.addEventListener("start", ()=>{ userMovedCamera=true; });
    scene.add(new THREE.HemisphereLight(0xffffff, 0x666666, 0.85));
    const key = new THREE.DirectionalLight(0xffffff, 1.0);
    key.position.set(3,5,2); key.castShadow = true;
    key.shadow.mapSize.set(2048,2048);
    key.shadow.camera.left=-3; key.shadow.camera.right=3; key.shadow.camera.top=3; key.shadow.camera.bottom=-3;
    key.shadow.bias=-0.0004; scene.add(key);
    const fill = new THREE.DirectionalLight(0xffffff, 0.35); fill.position.set(-3,2,-2); scene.add(fill);
    const floor = new THREE.Mesh(new THREE.PlaneGeometry(20,20), new THREE.ShadowMaterial({opacity:0.18}));
    floor.rotation.x=-Math.PI/2; floor.receiveShadow=true; scene.add(floor);
    const wall = new THREE.Mesh(new THREE.PlaneGeometry(20,8), new THREE.MeshStandardMaterial({color:0xd9c4b4, roughness:1}));
    wall.position.set(0,4,-1.3); wall.receiveShadow=true; scene.add(wall);
    window.addEventListener("resize", onResize);
    animate();
  }
  function onResize(){
    const holder = document.getElementById("configurator-canvas").parentElement;
    camera.aspect = holder.clientWidth/holder.clientHeight; camera.updateProjectionMatrix();
    renderer.setSize(holder.clientWidth, holder.clientHeight);
  }
  function animate(){ requestAnimationFrame(animate); controls.update(); renderer.render(scene, camera); }

  function panel(w,h,d,material){
    const mesh = new THREE.Mesh(new THREE.BoxGeometry(w,h,d), material);
    mesh.castShadow=true; mesh.receiveShadow=true; return mesh;
  }

  function makeHandle(type, orientation){
    const g = new THREE.Group();
    if (type==="tipon") return g;
    const mat = metalMaterial();
    if (type==="knob"){ g.add(new THREE.Mesh(new THREE.SphereGeometry(0.014,16,12), mat)); }
    else { const bar = new THREE.Mesh(new THREE.CylinderGeometry(0.007,0.007,0.13,12), mat);
      if (orientation==="h") bar.rotation.z=Math.PI/2; g.add(bar); }
    return g;
  }

  function legAnchorPoints(shape, w, d, inset){
    if (shape === "round") {
      const r = Math.min(w,d)/2 - inset;
      return [45,135,225,315].map((deg)=>{
        const rad = deg*Math.PI/180;
        return [Math.cos(rad)*r, Math.sin(rad)*r];
      });
    }
    if (shape === "oval") {
      const rx = w/2 - inset, ry = d/2 - inset;
      return [45,135,225,315].map((deg)=>{
        const rad = deg*Math.PI/180;
        return [Math.cos(rad)*rx, Math.sin(rad)*ry];
      });
    }
    return [[-w/2+inset,-d/2+inset],[w/2-inset,-d/2+inset],[-w/2+inset,d/2-inset],[w/2-inset,d/2-inset]];
  }

  function buildTable(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,topT=0.035; const group=new THREE.Group();
    const matTop = panelMaterial(matKey, w, d);
    let top;
    if (state.topShape==="round"){
      const r=Math.min(w,d)/2; top=new THREE.Mesh(new THREE.CylinderGeometry(r,r,topT,64), matTop);
      top.position.set(0,h-topT/2,0);
    } else if (state.topShape==="oval"){
      const shape=new THREE.Shape(); shape.absellipse(0,0,w/2,d/2,0,Math.PI*2,false,0);
      const geo=new THREE.ExtrudeGeometry(shape,{depth:topT,bevelEnabled:false,curveSegments:48});
      geo.rotateX(-Math.PI/2); top=new THREE.Mesh(geo,matTop); top.position.set(0,h,0);
    } else {
      const rad=Math.min(state.cornerRadius*MM, Math.min(w,d)/2);
      const shape=roundedRect(w,d,rad);
      const geo=new THREE.ExtrudeGeometry(shape,{depth:topT,bevelEnabled:false});
      geo.rotateX(-Math.PI/2); top=new THREE.Mesh(geo,matTop); top.position.set(0,h,0);
    }
    top.castShadow=true; top.receiveShadow=true; group.add(top);
    const legH=h-topT;
    const inset=0.08;
    if (state.legType==="hidden"){
      const post=panel(0.08,legH,0.08, panelMaterial(matKey,0.08,legH)); post.position.set(0,legH/2,0); group.add(post);
      const base=panel(w*0.5,0.03,d*0.4, metalMaterial()); base.position.set(0,0.015,0); group.add(base);
    } else {
      const legMat = state.legType==="metal" ? metalMaterial() : panelMaterial(matKey,0.06,legH);
      const legT = state.legType==="metal" ? 0.04 : 0.06;
      const anchors = legAnchorPoints(state.topShape, w, d, inset);
      anchors.forEach(([x,z])=>{
        const leg=panel(legT,legH,legT,legMat); leg.position.set(x,legH/2,z); group.add(leg);
      });
    }
    return group;
  }
  function roundedRect(w,d,r){
    const s=new THREE.Shape(); const x=-w/2,y=-d/2;
    s.moveTo(x+r,y); s.lineTo(x+w-r,y); s.quadraticCurveTo(x+w,y,x+w,y+r);
    s.lineTo(x+w,y+d-r); s.quadraticCurveTo(x+w,y+d,x+w-r,y+d);
    s.lineTo(x+r,y+d); s.quadraticCurveTo(x,y+d,x,y+d-r);
    s.lineTo(x,y+r); s.quadraticCurveTo(x,y,x+r,y); return s;
  }

  function buildWardrobe(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.018;
    const plinth = state.mounted?0:0.06; const bodyH=h-plinth; const yBase=plinth;
    const group=new THREE.Group();
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,bodyH), matDoor=panelMaterial(matKey,w,bodyH);
    if (plinth>0){ const pl=panel(w-0.02,plinth,d-0.04,matH); pl.position.set(0,plinth/2,0); group.add(pl); }
    const left=panel(t,bodyH,d,matV); left.position.set(-w/2+t/2,yBase+bodyH/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const bottom=panel(w-2*t,t,d,matH); bottom.position.set(0,yBase+t/2,0); group.add(bottom);
    const topP=bottom.clone(); topP.position.y=yBase+bodyH-t/2; group.add(topP);
    const back=panel(w-2*t,bodyH-2*t,0.006,matH); back.position.set(0,yBase+bodyH/2,-d/2+0.005); group.add(back);
    const innerBottom=yBase+t, innerTop=yBase+bodyH-t, innerH=innerTop-innerBottom;
    for (let i=1;i<=state.shelves;i++){ const sh=panel(w-2*t,t,d-0.03,matH);
      sh.position.set(0,innerBottom+(innerH/(state.shelves+1))*i,-0.01); group.add(sh); }
    if (state.rod){ const rod=new THREE.Mesh(new THREE.CylinderGeometry(0.012,0.012,w-2*t-0.04,12),metalMaterial());
      rod.rotation.z=Math.PI/2; rod.position.set(0,innerTop-0.08,d*0.15); group.add(rod); }
    for (let i=0;i<state.drawers;i++){ const drH=0.16; const dr=panel(w-2*t-0.01,drH-0.006,0.02,matDoor);
      dr.position.set(0,innerBottom+drH/2+i*drH,d/2-0.01); group.add(dr);
      const hh=makeHandle(state.handle,"h"); hh.position.set(0,innerBottom+drH-0.03+i*drH,d/2+0.008); group.add(hh); }
    const doorBottom=innerBottom+state.drawers*0.16; const doorH=innerTop-doorBottom-0.005;
    if (doorH>0.1){ const doorCount=w>1.0?2:1; const gap=0.005; const doorW=(w-2*t-gap*(doorCount+1))/doorCount;
      for (let i=0;i<doorCount;i++){ const door=panel(doorW,doorH,0.02,matDoor);
        const dx=-w/2+t+gap+doorW/2+i*(doorW+gap); door.position.set(dx,doorBottom+doorH/2,d/2-0.01); group.add(door);
        if (state.handle!=="tipon"){ const side=i===0?1:-1; const hnd=makeHandle(state.handle,"v");
          hnd.position.set(dx+side*(doorW/2-0.04),doorBottom+doorH/2,d/2+0.008); group.add(hnd); } } }
    return group;
  }

  function buildTVStand(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.018; const group=new THREE.Group();
    const legH=state.mounted?0:0.05; const bodyH=h-legH;
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,bodyH);
    if (legH>0){ [[-w/2+0.05,-d/2+0.05],[w/2-0.05,-d/2+0.05],[-w/2+0.05,d/2-0.05],[w/2-0.05,d/2-0.05]].forEach(([x,z])=>{
      const leg=panel(0.04,legH,0.04,matV); leg.position.set(x,legH/2,z); group.add(leg); }); }
    const bottom=panel(w,t,d,matH); bottom.position.set(0,legH+t/2,0); group.add(bottom);
    const topP=panel(w,t,d,matH); topP.position.set(0,legH+bodyH-t/2,0); group.add(topP);
    const left=panel(t,bodyH-2*t,d,matV); left.position.set(-w/2+t/2,legH+bodyH/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const back=panel(w-2*t,bodyH-2*t,0.006,matH); back.position.set(0,legH+bodyH/2,-d/2+0.005); group.add(back);
    const secW=w/3; const divL=panel(t,bodyH-2*t,d-0.02,matV); divL.position.set(-secW/2,legH+bodyH/2,0); group.add(divL);
    const divR=divL.clone(); divR.position.x=secW/2; group.add(divR);
    if (state.facade!=="niche"){ [-1,1].forEach((side)=>{ const dW=secW-t-0.01;
      const door=panel(dW,bodyH-2*t-0.01,0.018,matH);
      door.position.set(side*((secW/2)+(dW/2)+t/2),legH+bodyH/2,d/2-0.009); group.add(door);
      if (state.handle!=="tipon"){ const hnd=makeHandle(state.handle,"h");
        hnd.position.set(side*(secW/2+0.04),legH+bodyH*0.7,d/2+0.006); group.add(hnd); } }); }
    return group;
  }

  function buildWallCabinet(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.016; const group=new THREE.Group();
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,h), matDoor=panelMaterial(matKey,w,h);
    const bottom=panel(w,t,d,matH); bottom.position.set(0,t/2,0); group.add(bottom);
    const topP=panel(w,t,d,matH); topP.position.set(0,h-t/2,0); group.add(topP);
    const left=panel(t,h-2*t,d,matV); left.position.set(-w/2+t/2,h/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const back=panel(w-2*t,h-2*t,0.005,matH); back.position.set(0,h/2,-d/2+0.004); group.add(back);
    if (state.facade==="flap"){ const door=panel(w-0.008,h-0.008,0.016,matDoor); door.position.set(0,h/2,d/2-0.008); group.add(door);
      if (state.handle!=="tipon"){ const hnd=makeHandle(state.handle,"h"); hnd.position.set(0,0.06,d/2+0.006); group.add(hnd); } }
    else if (state.facade!=="niche"){ const doorCount=w>0.8?2:1; const gap=0.004; const doorW=(w-gap*(doorCount+1))/doorCount;
      for (let i=0;i<doorCount;i++){ const door=panel(doorW,h-0.008,0.016,matDoor);
        const dx=-w/2+gap+doorW/2+i*(doorW+gap); door.position.set(dx,h/2,d/2-0.008); group.add(door);
        if (state.handle!=="tipon"){ const side=doorCount===1?1:(i===0?1:-1); const hnd=makeHandle(state.handle,"v");
          hnd.position.set(dx+side*(doorW/2-0.03),h*0.15,d/2+0.006); group.add(hnd); } } }
    return group;
  }

  function buildWallShelf(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM; const group=new THREE.Group();
    const shelf=panel(w,h,d, panelMaterial(matKey,w,d)); shelf.position.set(0,h/2,0); group.add(shelf);
    const bMat=metalMaterial();
    [-1,1].forEach((side)=>{ const br=new THREE.Mesh(new THREE.BoxGeometry(0.02,0.12,d*0.8),bMat);
      br.position.set(side*(w/2-0.08),-0.06,-d*0.08); br.castShadow=true; group.add(br); });
    return group;
  }

  function buildBathVanity(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.016; const group=new THREE.Group();
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,h), matDoor=panelMaterial(matKey,w,h);
    const bottom=panel(w,t,d,matH); bottom.position.set(0,t/2,0); group.add(bottom);
    const topP=panel(w,t,d,matH); topP.position.set(0,h-t/2,0); group.add(topP);
    const left=panel(t,h-2*t,d,matV); left.position.set(-w/2+t/2,h/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const back=panel(w-2*t,h-2*t,0.005,matH); back.position.set(0,h/2,-d/2+0.004); group.add(back);
    const gap=0.004; const doorW=(w-gap*3)/2;
    [0,1].forEach((i)=>{ const door=panel(doorW,h-0.008,0.016,matDoor);
      const dx=-w/2+gap+doorW/2+i*(doorW+gap); door.position.set(dx,h/2,d/2-0.008); group.add(door);
      if (state.handle!=="tipon"){ const side=i===0?1:-1; const hnd=makeHandle(state.handle,"v");
        hnd.position.set(dx+side*(doorW/2-0.03),h*0.5,d/2+0.006); group.add(hnd); } });
    const ceramic=new THREE.MeshPhysicalMaterial({color:0xffffff,roughness:0.15,clearcoat:0.6});
    if (state.sinkType==="vessel"){ const basin=new THREE.Mesh(new THREE.CylinderGeometry(0.18,0.14,0.12,32),ceramic);
      basin.position.set(0,h+0.06,0); basin.castShadow=true; group.add(basin); }
    else { const rim=new THREE.Mesh(new THREE.CylinderGeometry(0.2,0.2,0.02,32),matH); rim.position.set(0,h+0.01,0); group.add(rim);
      const bowl=new THREE.Mesh(new THREE.SphereGeometry(0.17,32,16,0,Math.PI*2,0,Math.PI/2),ceramic);
      bowl.rotation.x=Math.PI; bowl.position.set(0,h+0.01,0); group.add(bowl); }
    if (state.led){ const ledMat=new THREE.MeshStandardMaterial({color:0x66ccff,emissive:0x3399ff,emissiveIntensity:2});
      const strip=panel(w*0.9,0.01,d*0.9,ledMat); strip.position.set(0,0.005,0); group.add(strip);
      const glow=new THREE.PointLight(0x66ccff,1.2,1.2); glow.position.set(0,-0.05,0); group.add(glow); }
    return group;
  }

  function buildBed(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM; const group=new THREE.Group();
    const frameH=0.25; const headH=h;
    const legH=state.legType==="hidden"?0.02:0.12;
    const mat=panelMaterial(matKey,w,d);
    const matHead=panelMaterial(matKey,w,headH);
    const legMat = state.legType==="metal"?metalMaterial():panelMaterial(matKey,0.06,legH);
    const legT=0.06;
    [[-w/2+0.08,-d/2+0.08],[w/2-0.08,-d/2+0.08],[-w/2+0.08,d/2-0.08],[w/2-0.08,d/2-0.08]].forEach(([x,z])=>{
      const leg=panel(legT,legH,legT,legMat); leg.position.set(x,legH/2,z); group.add(leg);
    });
    const sideL=panel(0.03,frameH,d,mat); sideL.position.set(-w/2+0.015,legH+frameH/2,0); group.add(sideL);
    const sideR=sideL.clone(); sideR.position.x=w/2-0.015; group.add(sideR);
    const foot=panel(w,frameH,0.03,mat); foot.position.set(0,legH+frameH/2,d/2-0.015); group.add(foot);
    const base=panel(w-0.06,0.02,d-0.06,mat); base.position.set(0,legH+frameH-0.05,0); group.add(base);
    const matressMat=new THREE.MeshStandardMaterial({color:0xf0ede6,roughness:0.9});
    const matress=panel(w-0.08,0.18,d-0.1,matressMat); matress.position.set(0,legH+frameH+0.05,0); group.add(matress);
    const headboard=panel(w,headH-legH,0.04,matHead);
    headboard.position.set(0,legH+(headH-legH)/2,-d/2+0.02); group.add(headboard);
    return group;
  }

  function buildDresser(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.018; const group=new THREE.Group();
    const legH=0.06; const bodyH=h-legH; const yBase=legH;
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,bodyH), matDr=panelMaterial(matKey,w,bodyH);
    [[-w/2+0.05,-d/2+0.05],[w/2-0.05,-d/2+0.05],[-w/2+0.05,d/2-0.05],[w/2-0.05,d/2-0.05]].forEach(([x,z])=>{
      const leg=panel(0.04,legH,0.04,matV); leg.position.set(x,legH/2,z); group.add(leg);
    });
    const left=panel(t,bodyH,d,matV); left.position.set(-w/2+t/2,yBase+bodyH/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const bottom=panel(w-2*t,t,d,matH); bottom.position.set(0,yBase+t/2,0); group.add(bottom);
    const topP=bottom.clone(); topP.position.y=yBase+bodyH-t/2; group.add(topP);
    const back=panel(w-2*t,bodyH-2*t,0.006,matH); back.position.set(0,yBase+bodyH/2,-d/2+0.005); group.add(back);
    const n=state.dresserDrawers; const innerH=bodyH-2*t; const drH=innerH/n;
    for (let i=0;i<n;i++){
      const dr=panel(w-2*t-0.01, drH-0.006, 0.02, matDr);
      dr.position.set(0, yBase+t+drH/2+i*drH, d/2-0.01); group.add(dr);
      if (state.handle!=="tipon"){ const hnd=makeHandle(state.handle,"h");
        hnd.position.set(0, yBase+t+drH/2+i*drH, d/2+0.008); group.add(hnd); }
    }
    return group;
  }

  function buildKitchen(W,H,D,matKey){
    const w=W*MM, totalH=H*MM, d=D*MM, t=0.018; const group=new THREE.Group();
    const baseH=0.85; const counterT=0.04; const gap=0.55; const upperH=0.72; const upperD=0.32; const plinth=0.1;
    const moduleW=0.6;
    const modules=Math.max(1, Math.round(w/moduleW));
    const actualModuleW=w/modules;
    const matH=panelMaterial(matKey,w,d);
    const matDoor=panelMaterial(matKey,actualModuleW,baseH);
    const counterMat=new THREE.MeshStandardMaterial({color:0x2e2e30,roughness:0.4,metalness:0.1});
    const pl=panel(w,plinth,d-0.05,new THREE.MeshStandardMaterial({color:0x222,roughness:0.8}));
    pl.position.set(0,plinth/2,-0.025); group.add(pl);
    for (let i=0;i<modules;i++){
      const cx=-w/2+actualModuleW/2+i*actualModuleW;
      const side=panel(t,baseH-plinth,d,panelMaterial(matKey,d,baseH));
      side.position.set(cx-actualModuleW/2+t/2, plinth+(baseH-plinth)/2, 0); group.add(side);
      const door=panel(actualModuleW-0.01, baseH-plinth-0.01, 0.018, matDoor);
      door.position.set(cx, plinth+(baseH-plinth)/2, d/2-0.009); group.add(door);
      if (state.handle!=="tipon"){ const hnd=makeHandle(state.handle,"v");
        hnd.position.set(cx+actualModuleW/2-0.04, plinth+(baseH-plinth)*0.8, d/2+0.006); group.add(hnd); }
    }
    const lastSide=panel(t,baseH-plinth,d,panelMaterial(matKey,d,baseH));
    lastSide.position.set(w/2-t/2, plinth+(baseH-plinth)/2, 0); group.add(lastSide);
    const counter=panel(w, counterT, d+0.02, counterMat);
    counter.position.set(0, baseH+counterT/2, 0.01); group.add(counter);
    if (state.sinkCut){
      const sink=new THREE.Mesh(new THREE.BoxGeometry(0.5,0.02,0.4),
        new THREE.MeshStandardMaterial({color:0x9a9da1,metalness:0.7,roughness:0.3}));
      sink.position.set(-w/4, baseH+counterT-0.005, 0.02); group.add(sink);
    }
    if (state.hobCut){
      const hob=new THREE.Mesh(new THREE.BoxGeometry(0.58,0.015,0.5),
        new THREE.MeshStandardMaterial({color:0x141414,roughness:0.25,metalness:0.3}));
      hob.position.set(w/4, baseH+counterT+0.003, 0.02); group.add(hob);
    }
    const upperY=baseH+counterT+gap;
    for (let i=0;i<modules;i++){
      const cx=-w/2+actualModuleW/2+i*actualModuleW;
      const side=panel(t,upperH,upperD,panelMaterial(matKey,upperD,upperH));
      side.position.set(cx-actualModuleW/2+t/2, upperY+upperH/2, -d/2+upperD/2); group.add(side);
      const door=panel(actualModuleW-0.01, upperH-0.01, 0.018, panelMaterial(matKey,actualModuleW,upperH));
      door.position.set(cx, upperY+upperH/2, -d/2+upperD-0.009); group.add(door);
      if (state.handle!=="tipon"){ const hnd=makeHandle(state.handle,"v");
        hnd.position.set(cx+actualModuleW/2-0.04, upperY+0.06, -d/2+upperD+0.006); group.add(hnd); }
    }
    const upLastSide=panel(t,upperH,upperD,panelMaterial(matKey,upperD,upperH));
    upLastSide.position.set(w/2-t/2, upperY+upperH/2, -d/2+upperD/2); group.add(upLastSide);
    const upTop=panel(w,t,upperD,matH); upTop.position.set(0,upperY+upperH-t/2,-d/2+upperD/2); group.add(upTop);
    const upBot=panel(w,t,upperD,matH); upBot.position.set(0,upperY+t/2,-d/2+upperD/2); group.add(upBot);
    group.position.y=0;
    return group;
  }

  function buildTallCabinet(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.016; const group=new THREE.Group();
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,h), matDoor=panelMaterial(matKey,w,h);
    const left=panel(t,h,d,matV); left.position.set(-w/2+t/2,h/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const bottom=panel(w-2*t,t,d,matH); bottom.position.set(0,t/2,0); group.add(bottom);
    const topP=bottom.clone(); topP.position.y=h-t/2; group.add(topP);
    const back=panel(w-2*t,h-2*t,0.005,matH); back.position.set(0,h/2,-d/2+0.004); group.add(back);
    [0.27,0.73].forEach((frac)=>{
      const door=panel(w-0.008,h*0.46,0.016,matDoor); door.position.set(0,h*frac,d/2-0.008); group.add(door);
      if (state.handle!=="tipon"){ const hnd=makeHandle(state.handle,"v");
        hnd.position.set(w/2-0.03,h*frac,d/2+0.006); group.add(hnd); }
    });
    return group;
  }

  function buildMirrorCabinet(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM,t=0.014; const group=new THREE.Group();
    const matH=panelMaterial(matKey,w,d), matV=panelMaterial(matKey,d,h);
    const left=panel(t,h,d,matV); left.position.set(-w/2+t/2,h/2,0); group.add(left);
    const right=left.clone(); right.position.x=w/2-t/2; group.add(right);
    const bottom=panel(w-2*t,t,d,matH); bottom.position.set(0,t/2,0); group.add(bottom);
    const topP=bottom.clone(); topP.position.y=h-t/2; group.add(topP);
    const back=panel(w-2*t,h-2*t,0.005,matH); back.position.set(0,h/2,-d/2+0.004); group.add(back);
    const mirrorMat=new THREE.MeshStandardMaterial({color:0xbfd4d9,metalness:0.9,roughness:0.05});
    const doorCount=w>0.7?2:1; const gap=0.004; const doorW=(w-gap*(doorCount+1))/doorCount;
    for (let i=0;i<doorCount;i++){
      const door=panel(doorW,h-0.008,0.014,mirrorMat);
      const dx=-w/2+gap+doorW/2+i*(doorW+gap); door.position.set(dx,h/2,d/2-0.007); group.add(door);
    }
    if (state.led){
      [-1,1].forEach((side)=>{
        const ledMat=new THREE.MeshStandardMaterial({color:0xffffff,emissive:0xfff2d0,emissiveIntensity:2});
        const strip=panel(0.02,h*0.85,0.02,ledMat); strip.position.set(side*(w/2+0.02),h/2,d/2-0.05); group.add(strip);
      });
      const glow=new THREE.PointLight(0xfff2d0,0.8,1.5); glow.position.set(0,h/2,0.3); group.add(glow);
    }
    return group;
  }

  function buildSofaStraight(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM; const group=new THREE.Group();
    const legH = state.legType==="hidden" ? 0.03 : 0.12;
    const seatH = h*0.42, backH = h - seatH - legH, armW = Math.min(0.22, w*0.09);
    const fabric = fabricMaterial(matKey);
    const legMat = state.legType==="metal" ? metalMaterial() : panelMaterial(matKey,0.06,legH);

    [[-w/2+0.1,-d/2+0.1],[w/2-0.1,-d/2+0.1],[-w/2+0.1,d/2-0.1],[w/2-0.1,d/2-0.1]].forEach(([x,z])=>{
      const leg=panel(0.06,legH,0.06,legMat); leg.position.set(x,legH/2,z); group.add(leg);
    });

    const seatW = w - armW*2;
    const seat = panel(seatW, seatH, d*0.92, fabric);
    seat.position.set(0, legH+seatH/2, -d*0.02); group.add(seat);

    const back = panel(seatW, backH, 0.18, fabric);
    back.position.set(0, legH+seatH+backH/2, -d/2+0.09); group.add(back);

    [-1,1].forEach((side)=>{
      const arm = panel(armW, seatH+backH*0.55, d*0.9, fabric);
      arm.position.set(side*(w/2-armW/2), legH+(seatH+backH*0.55)/2, -d*0.03); group.add(arm);
    });

    const n = Math.max(2, Math.min(5, state.cushions || 3));
    const cushW = (seatW-0.04)/n;
    for (let i=0;i<n;i++){
      const cx = -seatW/2 + cushW/2 + i*cushW;
      const cushion = panel(cushW-0.03, 0.16, d*0.8, fabric);
      cushion.position.set(cx, legH+seatH+0.08, 0); group.add(cushion);
      const pillow = panel(cushW-0.06, 0.32, 0.14, fabric);
      pillow.position.set(cx, legH+seatH+0.32, -d/2+0.22); group.add(pillow);
    }
    return group;
  }

  function buildSofaCorner(W,H,D,matKey){
    const w=W*MM,h=H*MM,d=D*MM; const group=new THREE.Group();
    const legH = state.legType==="hidden" ? 0.03 : 0.12;
    const seatH = h*0.42, backH = h - seatH - legH, armW = 0.2;
    const chaiseDepth = Math.min(d*0.62, w*0.55);
    const fabric = fabricMaterial(matKey);
    const legMat = state.legType==="metal" ? metalMaterial() : panelMaterial(matKey,0.06,legH);
    const sign = state.cornerSide === "right" ? -1 : 1;

    function addLeg(x,z){ const leg=panel(0.06,legH,0.06,legMat); leg.position.set(x,legH/2,z); group.add(leg); }

    const longW = w;
    const longD = d - chaiseDepth;
    const longSeat = panel(longW - armW, seatH, longD*0.92, fabric);
    longSeat.position.set(0, legH+seatH/2, -d/2 + longD/2);
    group.add(longSeat);

    const longBack = panel(longW, backH, 0.18, fabric);
    longBack.position.set(0, legH+seatH+backH/2, -d/2+0.09); group.add(longBack);

    const chaiseW = Math.min(longW*0.42, 1.0);
    const chaiseX = sign * (longW/2 - chaiseW/2);
    const chaiseSeat = panel(chaiseW, seatH, chaiseDepth, fabric);
    chaiseSeat.position.set(chaiseX, legH+seatH/2, -d/2+longD + chaiseDepth/2); group.add(chaiseSeat);

    const armX = -sign * (longW/2 - armW/2);
    const arm = panel(armW, seatH+backH*0.55, longD*0.9, fabric);
    arm.position.set(armX, legH+(seatH+backH*0.55)/2, -d/2+longD/2); group.add(arm);

    const chaiseArm = panel(chaiseW, seatH+backH*0.35, armW*0.7, fabric);
    chaiseArm.position.set(chaiseX, legH+(seatH+backH*0.35)/2, -d/2+longD+chaiseDepth - armW*0.35);
    group.add(chaiseArm);

    addLeg(-longW/2+0.08, -d/2+0.08);
    addLeg(longW/2-0.08, -d/2+0.08);
    addLeg(armX + (sign>0?-1:1)*(armW/2-0.08), -d/2+longD-0.08);
    addLeg(chaiseX + (sign>0?1:-1)*(chaiseW/2-0.08), -d/2+d-0.08);
    addLeg(chaiseX + (sign>0?-1:1)*(chaiseW/2-0.08), -d/2+longD+0.08);

    const n = Math.max(2, Math.min(5, state.cushions || 3));
    const cushZoneW = longW - armW;
    const cushW = (cushZoneW-0.04)/n;
    for (let i=0;i<n;i++){
      const cx = -cushZoneW/2 + cushW/2 + i*cushW;
      const cushion = panel(cushW-0.03, 0.16, longD*0.8, fabric);
      cushion.position.set(cx, legH+seatH+0.08, -d/2+longD/2); group.add(cushion);
    }
    const chCushion = panel(chaiseW-0.06, 0.16, chaiseDepth*0.7, fabric);
    chCushion.position.set(chaiseX, legH+seatH+0.08, -d/2+longD+chaiseDepth/2); group.add(chCushion);

    return group;
  }

  let userMovedCamera=false;
  function rebuildModel(){
    const typeData=FURNITURE_TYPES[state.type];
    const model=typeData.builder(state.width,state.height,state.depth,state.material);
    if (currentModel){ scene.remove(currentModel); disposeModel(currentModel); }
    currentModel=model;
    if (typeData.mounted || (typeData.options.mountToggle && state.mounted)) currentModel.position.set(0,1.2,-0.9);
    else currentModel.position.set(0,0,0);
    scene.add(currentModel);
    fitCameraToModel();
    updateShareURL();
  }
  function fitCameraToModel(){
    if (userMovedCamera || !currentModel) return;
    const box=new THREE.Box3().setFromObject(currentModel);
    const size=box.getSize(new THREE.Vector3());
    const center=box.getCenter(new THREE.Vector3());
    const maxDim=Math.max(size.x,size.y,size.z);
    const dist=maxDim*1.6+0.8;
    camera.position.set(center.x+dist*0.65, center.y+dist*0.45, center.z+dist);
    controls.target.copy(center);
    controls.update();
  }
  function disposeModel(model){
    model.traverse((c)=>{ if(c.isMesh){ c.geometry.dispose();
      if(c.material.map) c.material.map.dispose();
      if(c.material.normalMap) c.material.normalMap.dispose(); c.material.dispose(); } });
  }
  function clampLimit(field,val){ const l=FURNITURE_TYPES[state.type].limits[field]; return Math.min(l[1],Math.max(l[0],val)); }

  function renderTypeOptions(){
    const sel=document.getElementById("cfg-type"); sel.innerHTML="";
    Object.keys(FURNITURE_TYPES).forEach((k)=>{ const o=document.createElement("option");
      o.value=k; o.textContent=T.types[k] || k; sel.appendChild(o); });
    sel.value=state.type;
  }
  function renderMaterialSwatches(){
    const holder=document.getElementById("cfg-material"); holder.innerHTML="";
    Object.keys(MATERIALS).forEach((key)=>{ const m=MATERIALS[key];
      const label = T.materials[key] || key;
      const btn=document.createElement("button"); btn.className="swatch"+(key===state.material?" active":""); btn.title=label;
      if (m.type==="wood"){ const t=makeWoodTexture(m.base,{grainCount:60,pores:false,knots:0});
        btn.style.backgroundImage="url('"+t.image.toDataURL()+"')"; btn.style.backgroundSize="cover"; }
      else { btn.style.background="#"+m.color.toString(16).padStart(6,"0"); }
      const lbl=document.createElement("span"); lbl.className="swatch-label"; lbl.textContent=label; btn.appendChild(lbl);
      btn.addEventListener("click",()=>{
        if (typeof learnFromCorrection==="function") learnFromCorrection("materials", key);
        state.material=key;
        holder.querySelectorAll(".swatch").forEach(b=>b.classList.remove("active")); btn.classList.add("active");
        rebuildModel(); });
      holder.appendChild(btn); });
  }
  function renderDynamicOptions(){
    const box=document.getElementById("cfg-dynamic"); box.innerHTML="";
    const opts=FURNITURE_TYPES[state.type].options;
    if (opts.topShape) box.appendChild(makeSelect(T.topShapeLabel,"topShape",T.topShapeOptions,state.topShape));
    if (opts.cornerRadius) box.appendChild(makeSlider(T.cornerRadiusLabel,"cornerRadius",0,150,1,state.cornerRadius));
    if (opts.legType) box.appendChild(makeSelect(T.legTypeLabel,"legType",labelsOf(T.legs),state.legType));
    if (opts.handle) box.appendChild(makeSelect(T.handleLabel,"handle",labelsOf(T.handles),state.handle));
    if (opts.facade) box.appendChild(makeSelect(T.facadeLabel,"facade",T.facadeOptions,state.facade));
    if (opts.mountToggle) box.appendChild(makeSelect(T.mountLabel,"mounted",T.mountOptions,String(state.mounted)));
    if (opts.sinkType) box.appendChild(makeSelect(T.sinkTypeLabel,"sinkType",T.sinkTypeOptions,state.sinkType));
    if (opts.led) box.appendChild(makeSelect(T.ledLabel,"led",T.onOff,String(state.led)));
    if (opts.fill){ box.appendChild(makeSlider(T.shelvesLabel,"shelves",0,8,1,state.shelves));
      box.appendChild(makeSlider(T.drawersLabel,"drawers",0,4,1,state.drawers));
      box.appendChild(makeSelect(T.rodLabel,"rod",T.yesNo,String(state.rod))); }
    if (opts.drawersOnly) box.appendChild(makeSlider(T.drawersLabel,"dresserDrawers",1,6,1,state.dresserDrawers));
    if (opts.sinkCut) box.appendChild(makeSelect(T.sinkLabel,"sinkCut",T.yesNo,String(state.sinkCut)));
    if (opts.hobCut) box.appendChild(makeSelect(T.hobLabel,"hobCut",T.yesNo,String(state.hobCut)));
    if (opts.cornerSide) box.appendChild(makeSelect(T.cornerSideLabel,"cornerSide",T.cornerSideOptions,state.cornerSide));
    if (opts.cushions) box.appendChild(makeSlider(T.cushionsLabel,"cushions",2,5,1,state.cushions));
  }
  function labelsOf(obj){ const out={}; Object.keys(obj).forEach((k)=>{ out[k]=obj[k]; }); return out; }
  const STR_FIELDS=["topShape","legType","handle","facade","sinkType","material","cornerSide"];
  function makeSelect(label,field,optionsObj,current){
    const g=document.createElement("div"); g.className="control-group";
    const l=document.createElement("label"); l.textContent=label; g.appendChild(l);
    const sel=document.createElement("select");
    Object.entries(optionsObj).forEach(([val,txt])=>{ const o=document.createElement("option");
      o.value=val; o.textContent=txt; if(val===String(current)) o.selected=true; sel.appendChild(o); });
    sel.addEventListener("change",(e)=>{ let v=e.target.value;
      if (v==="true") v=true; else if (v==="false") v=false;
      else if (!STR_FIELDS.includes(field) && !isNaN(v)) v=parseInt(v,10);
      state[field]=v; rebuildModel(); });
    g.appendChild(sel); return g;
  }
  function makeSlider(label,field,min,max,step,current){
    const g=document.createElement("div"); g.className="control-group";
    const l=document.createElement("label"); l.innerHTML=label+": <span>"+current+"</span>"; g.appendChild(l);
    const inp=document.createElement("input"); inp.type="range"; inp.min=min; inp.max=max; inp.step=step; inp.value=current;
    inp.addEventListener("input",(e)=>{ const v=parseInt(e.target.value,10); state[field]=v;
      l.querySelector("span").textContent=v; debouncedRebuild(); });
    g.appendChild(inp); return g;
  }
  function updateSizeUI(){
    const t=FURNITURE_TYPES[state.type];
    ["width","height","depth"].forEach((f)=>{ const range=document.getElementById("cfg-"+f);
      const num=document.getElementById("cfg-"+f+"-num");
      const lbl=document.getElementById("cfg-"+f+"-lbl");
      range.min=t.limits[f][0]; range.max=t.limits[f][1]; state[f]=clampLimit(f,state[f]);
      range.value=state[f]; num.value=state[f]; num.min=t.limits[f][0]; num.max=t.limits[f][1];
      if (lbl) lbl.textContent=state[f]; });
  }
  let debounceTimer=null;
  function debouncedRebuild(){ clearTimeout(debounceTimer); debounceTimer=setTimeout(rebuildModel,60); }
  function bindControls(){
    document.getElementById("cfg-type").addEventListener("change",(e)=>{
      if (typeof learnFromCorrection==="function") learnFromCorrection("types", e.target.value);
      state.type=e.target.value;
      const def=FURNITURE_TYPES[state.type].defaults; state.width=def.width; state.height=def.height; state.depth=def.depth;
      userMovedCamera=false; updateSizeUI(); renderDynamicOptions(); rebuildModel(); });
    ["width","height","depth"].forEach((f)=>{ const range=document.getElementById("cfg-"+f);
      const num=document.getElementById("cfg-"+f+"-num");
      const lbl=document.getElementById("cfg-"+f+"-lbl");
      range.addEventListener("input",(e)=>{ const v=clampLimit(f,parseInt(e.target.value,10)||0); state[f]=v; num.value=v; if(lbl)lbl.textContent=v; debouncedRebuild(); });
      num.addEventListener("change",(e)=>{ const v=clampLimit(f,parseInt(e.target.value,10)||0); state[f]=v; range.value=v; num.value=v; if(lbl)lbl.textContent=v; rebuildModel(); }); });
    document.getElementById("cfg-ar").addEventListener("click",exportAR);
    document.getElementById("cfg-share").addEventListener("click",copyShareURL);
    const smartBtn=document.getElementById("cfg-smart-btn");
    const smartInput=document.getElementById("cfg-smart-input");
    if (smartBtn && smartInput){
      smartBtn.addEventListener("click",()=>parseSmartText(smartInput.value));
      smartInput.addEventListener("keydown",(e)=>{ if(e.key==="Enter") parseSmartText(smartInput.value); });
    }
  }

  const NLP = window.FURNITURE_DICTIONARY || { types:{}, materials:{}, shapes:{}, features:{}, darkHints:[], lightHints:[], units:{} };
  const LEARNED = { types:{}, materials:{} };
  let lastQuery = { text:"", recognizedType:null, recognizedMaterial:null, words:[] };

  function wordsFor(category, key){
    const base = (NLP[category] && NLP[category][key]) ? NLP[category][key] : [];
    const learned = (LEARNED[category] && LEARNED[category][key]) ? LEARNED[category][key] : [];
    return base.concat(learned);
  }
  function matchAny(text, words){ return words.some(w => text.includes(w)); }

  function parseSmartText(text){
    if (!text || !text.trim()) return;
    const s = " " + text.toLowerCase() + " ";
    let changed = false;
    const fb = [];
    let recogType=null, recogMat=null;

    for (const type of Object.keys(NLP.types)){
      if (FURNITURE_TYPES[type] && matchAny(s, wordsFor("types",type))){ state.type=type; changed=true; recogType=type; fb.push(T.types[type] || type); break; }
    }

    let matFound=false;
    for (const mat of Object.keys(NLP.materials)){
      if (MATERIALS[mat] && matchAny(s, wordsFor("materials",mat))){ state.material=mat; changed=true; matFound=true; recogMat=mat; fb.push(T.materials[mat] || mat); break; }
    }
    if (!matFound){
      if (matchAny(s, NLP.darkHints||[])){ state.material="venge"; changed=true; recogMat="venge"; fb.push(T.materials.venge); }
      else if (matchAny(s, NLP.lightHints||[])){ state.material="dub_natur"; changed=true; recogMat="dub_natur"; fb.push(T.materials.dub_natur); }
    }

    let sizeSet=false;
    let m;
    if ((m = s.match(/(\d+[.,]?\d*)\s*(\u043c(?!\u043c)|m(?!m)|\u043c\u0435\u0442\u0440|meter|metre|\u0574\u0565\u057f\u0580|\u0574(?!\u0574))/))){
      const meters=parseFloat(m[1].replace(",",".")); state.width=clampVal("width",Math.round(meters*1000));
      changed=true; sizeSet=true; fb.push(T.fb.widthPrefix+state.width+T.fb.mm);
    }
    else if ((m = s.match(/(\d{2,3})\s*(\u0441\u043c|cm|\u057d\u0574)/))){
      state.width=clampVal("width",parseInt(m[1],10)*10); changed=true; sizeSet=true; fb.push(T.fb.widthPrefix+state.width+T.fb.mm);
    }
    else if ((m = s.match(/(\d{3,4})\s*(\u043c\u043c|mm|\u0574\u0574)/))){
      state.width=clampVal("width",parseInt(m[1],10)); changed=true; sizeSet=true; fb.push(T.fb.widthPrefix+state.width+T.fb.mm);
    }
    if ((m = s.match(/(\d{2,4})\s*[x\u0445*\u00d7]\s*(\d{2,4})/))){
      let a=parseInt(m[1],10), b=parseInt(m[2],10);
      if (a<400) a*=10; if (b<400) b*=10;
      state.width=clampVal("width",a); state.depth=clampVal("depth",b); changed=true; sizeSet=true;
      fb.push(state.width+"\u00d7"+state.depth+T.fb.mm);
    }
    if (!sizeSet && (m = s.match(/\s(\d{3,4})\s/))){
      state.width=clampVal("width",parseInt(m[1],10)); changed=true; sizeSet=true; fb.push(T.fb.widthPrefix+state.width+T.fb.mm);
    }

    if (state.type==="stol"){
      for (const shape of Object.keys(NLP.shapes||{})){
        if (matchAny(s, wordsFor("shapes",shape))){ state.topShape=shape; changed=true;
          fb.push({round:T.fb.round,oval:T.fb.oval,square:T.fb.square}[shape]); break; }
      }
    }
    if (state.type==="divan_corner" || state.type==="divan_straight"){
      if (matchAny(s, wordsFor("shapes","corner")||[])){ state.type="divan_corner"; changed=true; fb.push(T.fb.corner); }
      else if (matchAny(s, wordsFor("shapes","straight")||[])){ state.type="divan_straight"; changed=true; fb.push(T.fb.straight); }
    }

    const o = FURNITURE_TYPES[state.type].options;
    const F = NLP.features||{};
    if (matchAny(s, F.drawers||[])){
      if (o.fill){ state.drawers=Math.max(2,state.drawers); changed=true; fb.push(T.fb.withDrawers); }
      if (o.drawersOnly){ state.dresserDrawers=Math.max(3,state.dresserDrawers); changed=true; fb.push(T.fb.moreDrawers); }
    }
    if (matchAny(s, F.rod||[]) && o.fill){ state.rod=true; changed=true; fb.push(T.fb.rod); }
    if (matchAny(s, F.metalLegs||[]) && o.legType){ state.legType="metal"; changed=true; fb.push(T.fb.metalLegs); }
    if (matchAny(s, F.led||[]) && o.led){ state.led=true; changed=true; fb.push(T.fb.led); }
    if (matchAny(s, F.sink||[]) && o.sinkCut){ state.sinkCut=true; changed=true; fb.push(T.fb.sink); }
    if (matchAny(s, F.hob||[]) && o.hobCut){ state.hobCut=true; changed=true; fb.push(T.fb.hob); }
    if (matchAny(s, F.mounted||[]) && o.mountToggle){ state.mounted=true; changed=true; fb.push(T.fb.wallMounted); }
    else if (matchAny(s, F.floor||[]) && o.mountToggle){ state.mounted=false; changed=true; fb.push(T.fb.floorStanding); }

    lastQuery = { text: s, recognizedType: recogType, recognizedMaterial: recogMat, words: extractWords(s) };

    if (changed){
      const def=FURNITURE_TYPES[state.type].defaults;
      if (!sizeSet){ state.width=def.width; state.height=def.height; state.depth=def.depth; }
      else { if (!fb.some(f=>f.includes("\u00d7"))) state.depth = state.depth || def.depth; state.height=def.height; }
      userMovedCamera=false;
      syncAllUI();
      rebuildModel();
      showSmartFeedback("\u2713 " + fb.join(" \u00b7 "));
    } else {
      showSmartFeedback(T.helpText);
    }
  }

  function extractWords(s){ return s.split(/[\s,.;:!?()"'\/]+/).filter(w=> w.length>=3 && !/^\d+$/.test(w)); }

  function learnFromCorrection(category, chosenKey){
    if (!lastQuery.text || !lastQuery.words.length) return;
    const unknown = lastQuery.words.filter(w=> !isKnownWord(w));
    if (!unknown.length) return;
    if (!LEARNED[category][chosenKey]) LEARNED[category][chosenKey]=[];
    unknown.forEach(w=>{ if(!LEARNED[category][chosenKey].includes(w)) LEARNED[category][chosenKey].push(w); });
    lastQuery.words = [];
  }
  function isKnownWord(w){
    const cats=["types","materials","shapes"];
    for (const c of cats){ for (const key of Object.keys(NLP[c]||{})){
      if (wordsFor(c,key).some(dw=> dw.includes(w) || w.includes(dw))) return true; } }
    const F=NLP.features||{};
    for (const key of Object.keys(F)){ if ((F[key]||[]).some(dw=> dw.includes(w)||w.includes(dw))) return true; }
    if ((NLP.darkHints||[]).some(dw=>dw.includes(w))||(NLP.lightHints||[]).some(dw=>dw.includes(w))) return true;
    return false;
  }

  function clampVal(field,val){ const l=FURNITURE_TYPES[state.type].limits[field]; return Math.min(l[1],Math.max(l[0],val)); }
  function showSmartFeedback(msg){
    const el=document.getElementById("cfg-smart-feedback");
    if (el){ el.textContent=msg; el.style.opacity="1";
      clearTimeout(el._t); el._t=setTimeout(()=>{ el.style.opacity="0.5"; },4000); }
  }
  function syncAllUI(){
    document.getElementById("cfg-type").value=state.type;
    updateSizeUI(); renderDynamicOptions(); renderMaterialSwatches();
  }
  function updateShareURL(){
    const p=new URLSearchParams();
    ["type","material","width","height","depth","topShape","cornerRadius","legType","handle","facade","mounted","sinkType","led","shelves","drawers","rod","dresserDrawers","sinkCut","hobCut","cornerSide","cushions"].forEach((k)=>p.set(k,state[k]));
    window.history.replaceState(null,"",window.location.pathname+"?"+p.toString());
  }
  function copyShareURL(){ updateShareURL(); navigator.clipboard.writeText(window.location.href).then(()=>{
    const btn=document.getElementById("cfg-share"); const old=btn.textContent; btn.textContent=T.linkCopied;
    setTimeout(()=>btn.textContent=old,2000); }).catch(()=>{}); }
  function loadFromURL(){ const p=new URLSearchParams(window.location.search); if(![...p.keys()].length) return;
    ["type","material","topShape","legType","handle","facade","sinkType","cornerSide"].forEach((k)=>{ if(p.has(k)) state[k]=p.get(k); });
    ["width","height","depth","cornerRadius","shelves","drawers","dresserDrawers","cushions"].forEach((k)=>{ if(p.has(k)) state[k]=parseInt(p.get(k),10); });
    ["mounted","led","rod","sinkCut","hobCut"].forEach((k)=>{ if(p.has(k)) state[k]=p.get(k)==="true"; }); }
  function exportAR(){
    if (!currentModel || !THREE.GLTFExporter){ alert(T.arUnavailable); return; }
    const exporter=new THREE.GLTFExporter();
    exporter.parse(currentModel,(glb)=>{ const blob=new Blob([glb],{type:"model/gltf-binary"});
      const url=URL.createObjectURL(blob); const mv=document.getElementById("cfg-model-viewer");
      mv.setAttribute("src",url); mv.style.display="block"; mv.activateAR && mv.activateAR(); },{binary:true});
  }

  function rotatePlaceholder(){
    const input=document.getElementById("cfg-smart-input");
    if (!input) return;
    const examplesByLocale = {
      ru: ["белый шкаф 2 метра с ящиками","круглый дубовый стол","тёмная кровать 1800","серая кухня с мойкой","угловой диван 3 метра","комод орех 6 ящиков"],
      en: ["white wardrobe 2 meters with drawers","round oak table 1400","dark bed 1800","grey kitchen with sink","corner sofa 3 meters","walnut dresser 6 drawers"],
      hy: ["\u057d\u057a\u056b\u057f\u0561\u056f \u057a\u0561\u0570\u0561\u0580\u0561\u0576 2 \u0574\u0565\u057f\u0580 \u0564\u0561\u0580\u0561\u056f\u0576\u0565\u0580\u0578\u057e","\u056f\u056c\u0578\u0580 \u056f\u0561\u0572\u0576\u056b \u057d\u0565\u0572\u0561\u0576","\u0574\u0578\u0582\u0563 \u0561\u057f\u0561\u0574\u0576\u056b 1800","\u0561\u0576\u056f\u0575\u0578\u0582\u0576\u0561\u0575\u056b\u0576 \u0562\u0561\u0566\u0574\u0578\u0581 3 \u0574\u0565\u057f\u0580","\u0570\u0561\u0581\u056b \u056f\u0578\u0574\u0578\u0564 6 \u0564\u0578\u0582\u057c"]
    };
    const examples = examplesByLocale[LOCALE] || examplesByLocale.ru;
    let i=0;
    setInterval(()=>{ if(document.activeElement!==input){ i=(i+1)%examples.length; input.placeholder=examples[i]; } }, 3200);
  }

  function applyStaticStrings(){
    const set = (id, txt) => { const el = document.getElementById(id); if (el) el.textContent = txt; };
    set("cfg-canvas-hint", T.canvasHint);
    set("cfg-smart-label", T.smartLabel);
    set("cfg-smart-btn", T.buildBtn);
    set("cfg-category-label", T.categoryLabel);
    set("cfg-width-text", T.widthLabel); set("cfg-width-unit", T.mmUnit);
    set("cfg-height-text", T.heightLabel); set("cfg-height-unit", T.mmUnit);
    set("cfg-depth-text", T.depthLabel); set("cfg-depth-unit", T.mmUnit);
    set("cfg-material-label", T.materialLabel);
    set("cfg-ar", T.arBtn);
    set("cfg-share", T.shareBtn);
    set("cfg-hint-text", T.hintText);
    const input = document.getElementById("cfg-smart-input");
    if (input) input.placeholder = T.smartPlaceholder;
  }

  document.addEventListener("DOMContentLoaded", function(){
    applyStaticStrings();
    loadFromURL(); initScene(); renderTypeOptions(); renderMaterialSwatches();
    updateSizeUI(); renderDynamicOptions(); bindControls(); rebuildModel();
    rotatePlaceholder();
  });
})();
